import { Button, Icon, SR_ICONS } from '@sr/ui-library';

export interface MobileHeaderProps {
  isSidebarOpen: boolean;
  onMenuToggle: () => void;
}

/**
 * Mobile header component with hamburger menu button.
 * Only visible on mobile (below md breakpoint).
 * Includes the Screenrights logo, hamburger menu, and rainbow gradient line.
 */
export const MobileHeader = ({
  isSidebarOpen,
  onMenuToggle,
}: MobileHeaderProps) => {
  return (
    <header className="md:hidden">
      <div className="container flex h-14 items-center justify-between bg-white max-md:px-4">
        <img
          alt="Screenrights logo"
          className="h-5"
          src="/screenrights-logo.png"
        />
        <Button
          aria-expanded={isSidebarOpen}
          aria-label="Open navigation menu"
          className="!text-sr-black"
          overrideClass={false}
          size="icon"
          variant="ghost"
          onClick={onMenuToggle}
        >
          <Icon icon={SR_ICONS.list} size="sm" weight="bold" />
        </Button>
      </div>

      <div
        className="h-px"
        style={{
          background:
            'linear-gradient(90deg, rgba(255, 216, 10, 0) 0%, #FFD80A 20.21%, #2B982F 30%, #068FA6 40%, #616CD1 50%, #D61C6A 60%, #0066DD 70%, #DF2F1A 80%, rgba(223, 47, 26, 0) 100%)',
        }}
      />
    </header>
  );
};
